import { render, staticRenderFns } from "./UserPhoneBind.vue?vue&type=template&id=0a2db325&scoped=true&"
import script from "./UserPhoneBind.vue?vue&type=script&lang=js&"
export * from "./UserPhoneBind.vue?vue&type=script&lang=js&"
import style0 from "./UserPhoneBind.vue?vue&type=style&index=0&id=0a2db325&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2db325",
  null
  
)

export default component.exports